var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      staticClass: "cliente-escopo ia-texto-corpo px-3 py-1",
      class: { "cliente-escopo--estreito": _vm.estreito },
      attrs: { title: _vm.tituloDaLinha }
    },
    [
      _c(
        "div",
        { staticClass: "cliente-escopo__linha" },
        [
          _c("span", {
            staticClass: "cliente-escopo__status",
            attrs: { "aria-hidden": "true" }
          }),
          _c("span", { staticClass: "cliente-escopo__nome" }, [
            _vm._v(_vm._s(_vm.nome))
          ]),
          _vm.detalhe
            ? _c("span", { staticClass: "cliente-escopo__detalhe" }, [
                _vm._v(_vm._s(_vm.detalhe))
              ])
            : _vm._e(),
          _vm.mostraAgenteBadge
            ? _c("AgentBadge", {
                attrs: {
                  hub: _vm.agente.hub,
                  "agent-slug": _vm.agente.agentSlug || "",
                  motivo: _vm.agente.motivo || "",
                  estado: _vm.estadoDoAgenteBadge
                }
              })
            : _vm._e(),
          _c("span", {
            staticClass: "cliente-escopo__separador",
            attrs: { "aria-hidden": "true" }
          }),
          _vm.travado
            ? _c("icon-svg", {
                staticClass: "flex-shrink-0",
                attrs: {
                  name: "lock",
                  size: _vm.TAMANHO_ICONE,
                  color: "var(--neutral-600)"
                }
              })
            : _vm._e(),
          _c("span", { staticClass: "cliente-escopo__resumo" }, [
            _vm._v(_vm._s(_vm.textoDoMeio))
          ]),
          _c("span", { staticClass: "cliente-escopo__acoes" }, [
            _vm.temAviso
              ? _c(
                  "button",
                  {
                    staticClass:
                      "cliente-escopo__acao ia-texto-corpo cliente-escopo__acao--trocar",
                    attrs: { type: "button", title: _vm.avisoDeConversa },
                    on: { click: _vm.trocarParaClienteDoAviso }
                  },
                  [_vm._v(" Trocar ")]
                )
              : _vm._e(),
            _c(
              "button",
              {
                staticClass:
                  "cliente-escopo__acao ia-texto-corpo cliente-escopo__acao--perfil az-ds-hyperlink",
                attrs: { type: "button", title: "Ver perfil do cliente" },
                on: {
                  click: function($event) {
                    return _vm.$emit("abrir-perfil", _vm.cliente)
                  }
                }
              },
              [
                _vm._v(" Ver perfil "),
                _c("icon-svg", {
                  attrs: {
                    name: "arrow-left",
                    size: _vm.TAMANHO_ICONE,
                    color: "var(--primary)"
                  }
                })
              ],
              1
            ),
            !_vm.travado
              ? _c(
                  "button",
                  {
                    staticClass:
                      "cliente-escopo__acao ia-texto-corpo cliente-escopo__acao--limpar",
                    attrs: {
                      type: "button",
                      title: "Voltar a conversar sobre o escritório",
                      "aria-label": "Remover o cliente do escopo"
                    },
                    on: {
                      click: function($event) {
                        return _vm.$emit("limpar")
                      }
                    }
                  },
                  [
                    _c("icon-svg", {
                      attrs: {
                        name: "close",
                        size: _vm.TAMANHO_ICONE,
                        color: "var(--neutral-700)"
                      }
                    })
                  ],
                  1
                )
              : _vm._e()
          ])
        ],
        1
      ),
      _vm.temAviso
        ? _c(
            "div",
            { staticClass: "cliente-escopo__aviso ia-texto-auxiliar" },
            [_vm._v(_vm._s(_vm.avisoDeConversa))]
          )
        : _vm._e()
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }